var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncentivePaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 36925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_i_2816_72234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14466 20.4407C6.11849 20.579 5.1646 19.8896 4.97969 18.8759L4.75226 17.6293C4.68709 17.272 4.46193 16.9637 4.14051 16.7917L3.01901 16.1913C2.10712 15.7031 1.74276 14.5875 2.19206 13.6593L2.74463 12.5178C2.90299 12.1907 2.90299 11.8096 2.74463 11.4824L2.19206 10.3409C1.74276 9.41274 2.10712 8.29718 3.01901 7.809L4.14051 7.2086C4.46193 7.03653 4.68709 6.72822 4.75226 6.37095L4.97969 5.12432C5.1646 4.1107 6.11849 3.42124 7.14466 3.55952L8.40672 3.72958C8.76842 3.77831 9.13274 3.66055 9.39656 3.40962L10.3171 2.53406C11.0656 1.82215 12.2447 1.82215 12.9932 2.53406L13.9137 3.40962C14.1775 3.66055 14.5419 3.77831 14.9036 3.72958L16.1656 3.55952C17.1918 3.42124 18.1457 4.1107 18.3306 5.12432L18.3517 5.24024C18.5473 6.31205 19.2228 7.23697 20.187 7.75317L20.2913 7.809C21.2032 8.29718 21.5675 9.41274 21.1182 10.3409L20.5656 11.4824C20.4073 11.8096 20.4073 12.1907 20.5656 12.5178L21.1182 13.6593C21.5675 14.5875 21.2032 15.7031 20.2913 16.1913L19.1698 16.7917C18.8484 16.9637 18.6232 17.272 18.558 17.6293L18.3306 18.8759C18.1457 19.8896 17.1918 20.579 16.1656 20.4407L14.9036 20.2707C14.5419 20.2219 14.1775 20.3397 13.9137 20.5906L12.9932 21.4662C12.2447 22.1781 11.0656 22.1781 10.3171 21.4662L9.39656 20.5906C9.13274 20.3397 8.76842 20.2219 8.40672 20.2707L7.14466 20.4407Z",
    fill: "url(#paint0_linear_2816_72234)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7857 7.82697H9.21429C9.0974 7.82697 9 7.92437 9 8.04125V8.97632C9 9.0932 9.0974 9.1906 9.21429 9.1906H10.8896C11.4935 9.1906 12.039 9.54125 12.2922 10.0867H9.21429C9.0974 10.0867 9 10.1841 9 10.301V11.1776C9 11.2945 9.0974 11.3919 9.21429 11.3919H12.2922C12.039 11.9374 11.4935 12.288 10.8896 12.288H9.21429C9.0974 12.288 9 12.3854 9 12.5023V13.827C9 13.8854 9.01948 13.9438 9.05844 13.9828L11.9416 16.9438C11.9805 16.9828 12.039 17.0023 12.0974 17.0023H13.4221C13.5195 17.0023 13.5974 16.9438 13.6169 16.8659C13.6558 16.788 13.6364 16.6906 13.5779 16.6322L10.6948 13.6906H10.8896C12.2532 13.6906 13.4416 12.7361 13.7532 11.4114H14.7857C14.9026 11.4114 15 11.314 15 11.1971V10.3205C15 10.2036 14.9026 10.1062 14.7857 10.1062H13.7532C13.6753 9.75554 13.5195 9.42437 13.3247 9.13216H14.7857C14.9026 9.13216 15 9.03476 15 8.91787V8.04125C15 7.92437 14.9026 7.82697 14.7857 7.82697Z",
    fill: "white",
    stroke: "url(#paint1_linear_2816_72234)",
    strokeWidth: 0.169459
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2816_72234",
    x: 2,
    y: 2.00012,
    width: 19.3105,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2816_72234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2816_72234",
    x1: 1.61616,
    y1: 3.37511,
    x2: 29.64,
    y2: 4.69179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BA7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2816_72234",
    x1: 8.88073,
    y1: 8.45776,
    x2: 17.5985,
    y2: 8.73518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32BA7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentivePaid);
export default __webpack_public_path__ + "static/media/incentive_paid.d9115d30169de9f970f4d8dd8008552d.svg";
export { ForwardRef as ReactComponent };